import { render, staticRenderFns } from "./YetiMapLegend.vue?vue&type=template&id=7632a1e4&scoped=true"
import script from "./YetiMapLegend.vue?vue&type=script&lang=js"
export * from "./YetiMapLegend.vue?vue&type=script&lang=js"
import style0 from "./YetiMapLegend.vue?vue&type=style&index=0&id=7632a1e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632a1e4",
  null
  
)

export default component.exports